module.exports = __webpack_public_path__ + "static/media/qr-android.bdf2a134.png";